import type { destination as destinationEn } from "../../en/webHints/destination";

// Nápovědy polí editoru destinace a lokality (řez 10). Klíče volá registr nápověd
// (`apps/admin/src/lib/webHints/destination.ts`). Text „web“ jmenuje „<stránka> → <sekce>“ bez
// předpony „Na webu:“; text „backoffice“ navazuje na „Nezobrazuje se na webu, slouží pro“.
export const destination: typeof destinationEn = {
  name: "Stránka destinace → drobečková navigace a nadpisy sekcí („Kam vyrazit v …“, „Proč cestovat do …“); dále název v mega menu, hledání a na kartách destinace",
  slug: "Adresa stránky → /destinace/<adresa> (u lokality /destinace/<země>/<adresa>); dále odkazy na destinaci v menu, výpisech a hledání",
  continent:
    "Stránka destinace → drobečková navigace; dále skupina kontinentu v mega menu a na stránce Destinace",
  parentId:
    "Stránka lokality → adresa /destinace/<země>/<lokalita>, drobečková navigace, infobox o zemi a sousední lokality v „Kam vyrazit“",
  parentIdCountry:
    "Stránka destinace → zařazení: prázdné = samostatná země s adresou /destinace/<adresa>; u místa vystupujícího jako země (Bali) se jeho zájezdy započítají i nadřazené zemi a adresa zůstává krátká",
  parentInfoText:
    "Stránka lokality → infobox o zemi (text pod větou s odkazem na zemi; prázdné = jen věta)",
  latitude:
    "Výpis zájezdů v pohledu Mapa → poloha bodů zájezdů této destinace (hotel s vlastními souřadnicemi má vlastní bod); na stránce destinace se nezobrazuje",
  longitude:
    "Výpis zájezdů v pohledu Mapa → poloha bodů zájezdů této destinace (hotel s vlastními souřadnicemi má vlastní bod); na stránce destinace se nezobrazuje",
  heroTitle:
    "Stránka destinace → velký titulek přes úvodní fotku; prázdné = „Název – krátký popis“",
  heading: "Stránka destinace → nadpis H1 nad popisem destinace; prázdné = „Název – krátký popis“",
  shortDescription:
    "Vyhledávače → meta popis stránky, když chybí Meta popis; dále náhradní text titulku a H1, stránky měsíců, stránka inspirace a popis videa v Cestovní akademii",
  climateInfo: "Stránka destinace → Počasí, řádek Klima (sekce jen s údaji o počasí)",
  bestTimeToVisit:
    "Stránka destinace → Počasí, Nejlepší doba návštěvy (sekce jen s údaji o počasí)",
  description: "Stránka destinace → úvodní text pod nadpisem H1",
  metaTitle: "Vyhledávače a sdílení → titulek stránky; prázdné = „Název – poznejte … s CK Go2“",
  metaDescription:
    "Vyhledávače a sdílení → popis stránky ve výsledcích hledání; prázdné = Krátký popis",
  featuredImageId:
    "Stránka destinace → úvodní fotka; dále náhled při sdílení, karta destinace a záložní fotka sekcí videa a „O …“",
  guideId:
    "přiřazení průvodce k destinaci ve veřejném API (detail destinace ho vydává jako průvodce, detail průvodce jako jeho destinaci); web ho nevykresluje. Kontakty, které zákazník vidí u destinace, se zadávají v Kontaktech a týmech",
  sortOrder:
    "řazení zemí a míst: u země bez nadřazené destinace 0 = abecedně, číslo větší než 0 = připnutí na začátek (v menu, na stránce Destinace a ve filtrech na začátek svého kontinentu, v patičce a mezi zeměmi inspirací na začátek celého seznamu; nižší číslo dřív); u místa (i místa vystupujícího jako země, např. Bali) pořadí v „Kam vyrazit“ a výběr míst do menu (nižší číslo dřív); číslo samo se nikde nevypisuje",
  defaultMinPax: "předvyplnění obsazenosti nových kalkulací zájezdů této destinace (prázdné = 10)",
  autoRouteLeads:
    "automatické přidělení poptávek garantovi destinace (když je zapnuté v Nastavení → AI)",
  isFeatured:
    "Úvodní stránka → „Populární hledání“ (jen s volbou Nabízet v menu); v mega menu přednost mezi lokalitami země",
  isPublished:
    "Celý web → stránka destinace, menu, výpisy a hledání (nepublikovaná je všude skrytá, adresa vrací 404)",
  showInNav:
    "Mega menu, filtr „Kam“ a hledání na úvodní stránce → nabídka destinací (odškrtnutá má dál svou stránku a najde se napsáním názvu)",
  showAsCountry:
    "Mega menu a stránka Destinace → místo vystupuje jako země (vlastní dlaždice, krátká adresa /destinace/<adresa>); zařazení pod zemí zůstává",
  highlights:
    "Stránka destinace → „To nejlepší z …“ (karty s obrázkem, nadpisem a popisem); prázdné = sekce chybí",
  regions:
    "Stránka destinace → „Kam vyrazit v …“, jen když destinace nemá žádnou publikovanou lokalitu (u lokality sousední); web ukáže název a obrázek, popis regionu čte jen AI asistent adminu",
  testimonial:
    "Stránka destinace → citace přes fotku pod galerií a sekcí videa (citát, podpis Autor s jeho fotkou, jinak garant destinace, fotka na pozadí); bez citátu se sekce nezobrazí",
  additionalContent: "Stránka destinace → „O …“ na konci stránky; prázdné = sekce chybí",
  additionalImageId:
    "Stránka destinace → fotka vedle textu „O …“ (jen s Doplňkovým textem; prázdné = úvodní fotka)",
  practicalInfoVisa:
    "Stránka destinace → Časté dotazy a užitečné tipy → Užitečné tipy, otázka „Doklady potřebné ke vstupu do země“ (prázdné = otázka chybí)",
  practicalInfoCurrency:
    "Stránka destinace → Časté dotazy a užitečné tipy → Užitečné tipy, otázka „Měna a platby“ (prázdné = otázka chybí)",
  practicalInfoLanguage:
    "Stránka destinace → Časté dotazy a užitečné tipy → Užitečné tipy, otázka „Jazyk“ (prázdné = otázka chybí)",
  practicalInfoTimezone:
    "Stránka destinace → Časté dotazy a užitečné tipy → Užitečné tipy, otázka „Časový posun“ (prázdné = otázka chybí)",
  practicalInfoElectricity:
    "Stránka destinace → Časté dotazy a užitečné tipy → Užitečné tipy, otázka „Elektrické zásuvky“ (prázdné = otázka chybí)",
  practicalInfoVaccination:
    "Stránka destinace → Časté dotazy a užitečné tipy → Užitečné tipy, otázka „Doporučená očkování“ (prázdné = otázka chybí)",
  weatherData:
    "Stránka destinace → Počasí (měsíce nejlepší a dobré, teploty, popis, text vybraného měsíce, jinak celkový popis, místní tip); dále stránky měsíců; lokalita bez vlastních údajů ukáže počasí země",
  cuisine:
    "Stránka destinace → Časté dotazy a užitečné tipy → Užitečné tipy, otázka „Kde se v … dobře najíst“ (prázdné = otázka chybí)",
  activities:
    "Stránka destinace → karusel aktivit, jen když destinace nemá žádnou inspiraci (názvy bez odkazu)",
  whyWithUs:
    "Stránka destinace → „Proč cestovat do … s CK Go2“ (karty s piktogramem); prázdné = obecné výhody CK Go2",
  heroVideoUrl:
    "Stránka destinace → sekce videa pod galerií, těsně před citací (bez platné adresy chybí; lokalita video země nepřebírá); dále Travel Akademie na úvodní stránce, Cestovní akademie a stránky inspirací destinace",
  videoPromo:
    "Stránka destinace → sekce videa: nadpis, popis a náhled; nadpis a popis i u videa v Cestovní akademii",
  moreVideosUrl:
    "Stránka destinace → tlačítko na další videa v sekci videa (prázdné = YouTube kanál CK Go2)",
  galleryImageIds:
    "Stránka destinace → fotogalerie; bez vybraných fotek ukáže staré fotky z doby před knihovnou médií, a teprve když nejsou ani ty, se nezobrazí",
  socialReels:
    "Stránka destinace → „Nechte se inspirovat“ (reels, nejvýš 12; bez jediného videa sekce chybí). Země i místo vystupující jako země ukazují jen vlastní reels; lokalita nejdřív vlastní, za nimi reels své země se štítkem země na kartě a větou o zdroji pod nadpisem",
  faqs: "Stránka destinace → Časté dotazy a užitečné tipy (redakční kategorie před Užitečnými tipy); prázdné = obecné dotazy CK Go2",
  offerIntro:
    "Výpis zájezdů destinace (/zajezdy/<destinace>, u typu jeho varianta) → úvodní text pod nadpisem; zároveň podmínka indexace",
  offerFaqs: "Výpis zájezdů destinace → Časté dotazy pod výpisem",
  planningBlockVariant:
    "Stránka destinace → text sekce zájezdů, když destinace nemá žádný zájezd (varianta z Nastavení → Obsah webu; lokality ho nedědí)",
  planningBlockText:
    "Stránka destinace → text sekce zájezdů bez zájezdů; vlastní text přebije variantu",
  inspirationIds:
    "Stránka destinace → karusel aktivit (inspirace této destinace); výběr se uloží přímo do inspirací",
};
